import Swiper from 'swiper/bundle';

export default class Carousel {
    constructor(element) {
        this.element = element;
        this.init();
    }

    init() {
        const swiper = new Swiper(this.element, {
            slidesPerView: 1, // Nombre de slides visibles à la fois
            navigation: {
                nextEl: this.element.querySelector('.swiper-button-next'),
                prevEl: this.element.querySelector('.swiper-button-prev'),
            },
            loop: true, // Active le défilement infini
            on: {
                slideChange: () => {
                    console.log('Slide changée');
                },
                slideNextTransitionStart: () => {
                    console.log('Next button clicked');
                },
                slidePrevTransitionStart: () => {
                    console.log('Prev button clicked');
                },
            },
        });
    }
}
